import { z } from 'zod';

export const capacitySearchSchema = z.object({
  q: z.string().optional(),
});

export type CapacitySearchParams = z.output<typeof capacitySearchSchema>;
